import { render, staticRenderFns } from "./IntegralExchangeDetail.vue?vue&type=template&id=5f10e68e&scoped=true&"
import script from "./IntegralExchangeDetail.vue?vue&type=script&lang=js&"
export * from "./IntegralExchangeDetail.vue?vue&type=script&lang=js&"
import style0 from "./IntegralExchangeDetail.vue?vue&type=style&index=0&id=5f10e68e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f10e68e",
  null
  
)

export default component.exports